import styled from 'styled-components';

export const BadgeContainer = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  margin-top: 4px;
`;

export const LabelBadge = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
`;

export const BadgeLabel = styled.div`
  font-size: 8px;
  color: #666;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.3px;
`;

export const GradeBadge = styled.div`
  background-color: ${({ color }) => color};
  color: white;
  font-weight: 700;
  font-size: 12px;
  width: 22px;
  height: 22px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
`;

export const NoiseBadge = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
`;

export const NoiseValue = styled.div`
  font-size: 11px;
  font-weight: 700;
  color: #333;
  display: flex;
  align-items: baseline;
  gap: 1px;
`;

export const NoiseDb = styled.span`
  font-size: 8px;
  font-weight: 600;
  color: #666;
`;

export const NoiseWaves = styled.div`
  display: flex;
  gap: 1px;
`;

export const Wave = styled.div`
  width: 2px;
  height: 6px;
  background-color: ${({ active }) => (active ? '#333' : '#ddd')};
  border-radius: 1px;
`;
